export const createLogoutEndpoint = (endpoint: string): string => {
  return `${endpoint}/passport/api/v2/auth/logout`;
};
